import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthUserStore } from './auth-user.store';

export const selectAuthUserStore = createFeatureSelector<AuthUserStore>('authUser');

export const selectIsAuthenticated = createSelector(
  selectAuthUserStore,
  (state) => state.isAuthenticated
);

export const selectIsLoading = createSelector(
  selectAuthUserStore,
  (state) => state.isLoading
);

export const selectLoginType = createSelector(
  selectAuthUserStore,
  (state) => state.loginType
);

export const selectAuthError = createSelector(
  selectAuthUserStore,
  (state) => state.error
);

export const selectTokenExpiration = createSelector(
  selectAuthUserStore,
  (state) => state.tokenExpiration
);

export const selectIsPublicUser = createSelector(
  selectLoginType,
  (loginType) => loginType === 'public'
);

export const selectSessionId = createSelector(
  selectAuthUserStore,
  (state) => state.id
);
